import { LinkParagraph } from '@nexus/lib-react/dist/core/Link/LinkParagraph';
import styled from '@olxeu-a2b/ui/src/theme/styled';

const LinkButton = styled(LinkParagraph)`
  justify-content: center;
  padding: ${({ theme }) => theme.sizes[16]} 0 ${({ theme }) => theme.sizes[8]};
  font-size: ${({ theme }) => theme.space[14]};
  color: ${({ theme }) => theme.colors['text-global-secondary']};
`;

export default {
  LinkButton,
};
